import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./TreeViewFooter.scss";
import defaultContent from "../../../content/footer";
import { storedIsoCountry } from "../../../common/util/config";
import { ANA_MARKETS } from "../../../common/constants/market-constants";
import { ROUTE_PATHS } from "../../../common/enums/routing-enums";

/**
 * Same copy/logic as the site Footer (minus its links), rendered as a sticky
 * bar inside TreeView's fullscreen mode — the native Fullscreen API only
 * paints the fullscreened element and its descendants, so the site Footer
 * (mounted outside it) is invisible while fullscreen is active.
 */
export const TreeViewFooter = () => {
  const { t } = useTranslation(["footer"]);
  const isoCountryCode = storedIsoCountry();
  const { pathname } = useLocation();

  const isAna = ANA_MARKETS.includes(isoCountryCode);
  const showFirstContractYear = isAna && (pathname === ROUTE_PATHS.LOS || pathname === ROUTE_PATHS.WATCHLIST);

  return (
    <footer className="tree-view-footer">
      {showFirstContractYear && (
        <p className="tree-view-footer__fcy-text">
          {`${t("firstContractYear", String(defaultContent["firstContractYear"]))}`}
        </p>
      )}
      <div className="tree-view-footer__copyright">
        {`${t("copyright", defaultContent["copyright"], { YEAR: new Date().getFullYear() })}`}
      </div>
      <div>{`${t("confidential", String(defaultContent["confidential"]))}`}</div>
      <div>{`${t("aboOnlyLabel", String(defaultContent["aboOnlyLabel"]))}`}</div>
    </footer>
  );
};
